<template>
  <div class="page-login-inner">
    <div class="login-logo">
      <img src="@img/signal-logo.svg" alt="signal logo" />
    </div>
    <form
      class="login-form-box"
      v-if="state === 'enter-mobile'"
      key="enter-mobile"
      data-vv-scope="form-mobile"
      @submit.prevent="sendMobile"
    >
      <p class="text-center mb-4 font-12">
        فراموشی رمز عبور
      </p>
      <div class="el-input el-input--suffix">
        <input
          v-model="mobile"
          v-number.numeric
          v-focus
          v-validate="'required|numeric|mobile-no-zero'"
          data-vv-as="شماره موبایل"
          type="tel"
          placeholder="شماره موبایل"
          name="mobile"
          maxlength="11"
          class="el-input__inner force-ltr"
          style="direction:ltr;text-align:right"
        />
        <span class="el-input__suffix">
          <span class="el-input__suffix-inner">
            <i
              v-if="mobile"
              class="el-input__icon el-icon-back submit-icon"
              @click="sendMobile"
            />
            <i v-else class="el-input__icon el-icon-mobile-phone" />
          </span>
        </span>
      </div>
      <div class="text-center mt-4">
        <router-link to="/login">
          <p class="forgot-text">
            بازگشت به صفحه ورود
          </p>
        </router-link>
      </div>
    </form>
    <div v-else-if="state === 'link-sent'" class="login-form-box">
      <p class="text-center mb-4 font-12">
        فراموشی رمز عبور
      </p>
      <p class="text-center">
        لینک فراموشی رمز عبور برای شما پیامک شد، لطفا از طریق لینک ارسالی رمز
        عبور خود را تغییر دهید
      </p>
      <div class="text-center mt-4">
        <router-link to="/login">
          <p class="forgot-text">
            بازگشت به صفحه ورود
          </p>
        </router-link>
      </div>
    </div>
    <form
      class="login-form-box"
      v-else-if="state === 'enter-password'"
      key="enter-password"
      data-vv-scope="form-password"
      @submit.prevent="submitPassword"
    >
      <p class="text-center mb-4 font-12">
        فراموشی رمز عبور
      </p>
      <div class="el-input el-input--suffix">
        <input
          v-model="form.password"
          v-focus
          v-validate="'required'"
          data-vv-as="رمز عبور جدید"
          type="password"
          placeholder="رمز عبور جدید"
          name="password"
          class="el-input__inner force-ltr"
          style="direction:ltr;text-align:right"
        />
        <span class="el-input__suffix">
          <span class="el-input__suffix-inner">
            <i class="el-input__icon el-icon-lock" />
          </span>
        </span>
      </div>
      <div class="el-input el-input--suffix mt-2">
        <input
          v-model="form.passwordConfirm"
          v-validate="{
            required: true,
            confirmPassword: form.password
          }"
          data-vv-as="تکرار رمز عبور جدید"
          type="password"
          placeholder="تکرار رمز عبور جدید"
          name="passwordConfirm"
          class="el-input__inner force-ltr"
          style="direction:ltr;text-align:right"
        />
        <span class="el-input__suffix">
          <span class="el-input__suffix-inner">
            <i class="el-input__icon el-icon-lock" />
          </span>
        </span>
      </div>
      <div class="text-center mt-4">
        <button class="submit-btn font-11" type="submit">
          ثبت
        </button>
      </div>
      <div class="text-center mt-4">
        <router-link to="/login">
          <p class="forgot-text">
            بازگشت به صفحه ورود
          </p>
        </router-link>
      </div>
    </form>
    <div v-else-if="state === 'password-changed'" class="login-form-box">
      <p class="text-center mb-4 font-12">
        فراموشی رمز عبور
      </p>
      <p class="text-center">
        رمز عبور شما با موفقیت تغییر داده شد، لطفا با رمز عبور جدید خود وارد
        شوید
      </p>
      <div class="text-center mt-4">
        <router-link to="/login">
          <p class="forgot-text">
            بازگشت به صفحه ورود
          </p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/sass/pages/login.scss'
export default {
  name: 'ForgetPassword',
  data() {
    return {
      loading: false,
      form: {
        password: '',
        passwordConfirm: ''
      },
      state: 'enter-mobile',
      mobile: '',
      token: ''
    }
  },
  computed: {
    tel() {
      let mobile = this.mobile
      if (mobile.length > 10) mobile = mobile.replace(/^0/, '')
      return mobile
    },
    ref() {
      let ref = this.$route.query.ref || ''
      if (!ref || ref.includes('404')) ref = { name: 'home' }
      return ref
    }
  },
  watch: {
    state(after) {
      if (after === 'enter-code') {
        this.token = ''
      } else if (state === 'enter-password') {
      }
    }
  },
  created() {
    if (this.$route.query.token) {
      this.state = 'enter-password'
      this.token = this.$route.query.token
    } else {
      this.state = 'enter-mobile'
    }
  },
  methods: {
    sendMobile() {
      this.$store.commit('updateLoading', true)
      this.$validate('form-mobile').then(() => {
        this.$store
          .dispatch('auth/createResetPasswordToken', {
            $vm: this,
            $client: 'user',
            variables: { mobile: this.tel }
          })
          .then(() => {
            this.state = 'link-sent'
          })
          .finally(() => this.$store.commit('updateLoading', false))
      })
    },
    submitPassword() {
      this.$validate('form-password').then(() => {
        this.$store.commit('updateLoading', true)
        this.$store
          .dispatch('auth/resetPasswordViaToken', {
            $client: 'user',
            $vm: this,
            variables: {
              token: this.token,
              password: this.form.password,
              passwordConfirm: this.form.passwordConfirm
            }
          })
          .then(response => {
            this.$user.reset()
            this.state = 'password-changed'
          })
          .finally(() => this.$store.commit('updateLoading', false))
      })
    }
  }
}
</script>
